/* eslint-disable react/prop-types */
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { Checkbox, Button } from 'antd';
import { PRODUCT_NAME } from '@/constants';
import request from '@api';
import classes from './index.module.css';
import Loading from './Loading';

const getTitle = (name) => `Offer ${name === 'Shopify' ? PRODUCT_NAME.DELIVERY_GUARANTEE : PRODUCT_NAME.GREEN_SHIPPING_PROTECTION} that earns customer trust and loyalty.`;
const descMap = ['Protect orders against loss, damage, and delay', 'Eliminate shipping related customer complaints', 'Turn late deliveries into repeat customers'];

export default function Intro({ name, merchantId }) {
  // const form = Form.useFormInstance();
  const [confirmChecked, setConfirmChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onChange = (e) => {
    setConfirmChecked(e.target.checked);
  };
  const onSubmit = async () => {
    setLoading(true);
    try {
      const { code, message } = await request('open-platform-onboarding', {
        method: 'POST',
        body: {
          merchantId,
          bpOnboardingForm: {
            defaultOpt: 'default_on',
            fulfillType: 'fulfill_instant',
            pdpBanner: 'show',
          },
        },
      });
      if (code === 0) {
        console.log('submit success');
        navigate('./feedback');
      } else {
        navigate('./error', { state: { message } });
      }
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  };
  if (loading) {
    return <Loading />;
  }
  return (
    <div className={classes.intro}>
      <div className={classes.title}>
        {getTitle(name)}
      </div>
      <ul className={classes.desc}>
        {descMap.map((desc) => <li key={desc} className={classes.desc_item}>{desc}</li>)}
        <li><a href="https://kover2618.zendesk.com/hc/en-us/articles/17571948690587-Learn-more-about-Green-Shipping-Protection" target="_blank" rel="noreferrer">{'How does it work for Shopify merchants >'}</a></li>
      </ul>

      <div className={classes.confirm_check}>
        <Checkbox
          checked={confirmChecked}
          onChange={onChange}
          color="input"
          style={{ padding: '0px' }}
        />
        <span className={classes.confirm_text}>
          {'I have read and agreed to '}
          <a href="https://www.seel.com/terms/green-shipping-protection-for-merchant" className={classes.confirm_link} target="_blank" rel="noreferrer">Terms and Conditions</a>
        </span>
      </div>

      <Button
        type="primary"
        disabled={!confirmChecked}
        className={classes.next_button}
        onClick={onSubmit}
        loading={loading}
        htmlType="submit"
      >
        Enable now
      </Button>

    </div>

  );
}
